// extracted by mini-css-extract-plugin
export default {"activeSubSection":"user-active-sub-info_activeSubSection__HkvPA","active":"user-active-sub-info_active__b5a39"};